/* Common component used for the olivela logo */
import OlivelaLogoIcon from "@/components/Logos/OlivelaLogo";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
/* 
Props
height - required
width - required
*/
export default function OlivelaLogo({className,superbrandHeroPresent=false,tabIndex=false}) {
  const isDesktop=useMediaQuery("(min-width:1025px)");
  const colorDark= isDesktop?"#5d5d5d":"#2f2f30";
  return (
    <>
      <OlivelaLogoIcon fill={superbrandHeroPresent?'#ffffff':colorDark} className={className} tabIndex={tabIndex ? 0 : "none"}/>
    </>
  );
}
